import Container from '@material-ui/core/Container'
import React, { FC, useState } from 'react'
import { ImageContainer } from './style'

//* utils
import { EnlargeableImage } from '../../../constants/svg'
import ImgUtil from '../../../utils/img.utils'

//* components
import DottedModal from '../dottedModal'
import WrapperImage from '../wrapperImage'

type Props = {
  data: any
  outerPage?: string
  enlargeable?: boolean
}

const Image: FC<Props> = ({ data, outerPage, enlargeable = false }) => {
  const imageUrl = data?.imageFile?.file?.url || ''
  if (!imageUrl) return null

  const alt = data?.imageFile?.title || ''
  const alignmentClass = data?.imageSelfAlignment ? `Align--${data.imageSelfAlignment}` : ''

  let dottedModal = null
  let imageContainerProps = {}

  if (enlargeable) {
    const [open, setOpen] = useState(false)
    const handleClose = () => setOpen(false)
    const handleOpen = () => setOpen(true)

    dottedModal = (
      <DottedModal open={open} handleClose={handleClose} type="image">
        <WrapperImage
          src={ImgUtil.getResizedImageUrl(imageUrl, '')}
          loading="lazy"
          alt={alt}
          threshold={650}
        />
      </DottedModal>
    )

    imageContainerProps = {
      enlargeable: enlargeable,
      onClick: handleOpen,
    }
  }

  return (
    <>
      {dottedModal}
      <ImageContainer
        {...imageContainerProps}
        data-cy="image-Container"
        $outerPage={outerPage || 'generic'}
        $enlargeable={enlargeable}>
        {enlargeable && <EnlargeableImage />}

        <Container className={alignmentClass} data-cy="Image">
          <WrapperImage
            loading="lazy"
            alt={alt}
            className="Image__Element"
            src={ImgUtil.getResizedImageUrl(data.imageFile.file.url, '')}
            threshold={650}
          />
        </Container>
      </ImageContainer>
    </>
  )
}

export default Image
